import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Col, Row } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from '../../../../reducers/common/localization';
import './ApplicantRequestsModal.css';

class ApplicantRequestsModal extends Component {
    render() {
        if (_.isNil(this.props.requestors) || _.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="applicant-requests-modal" isOpen={this.props.isOpen}
                   toggle={this.handleClose}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'accreditation_requests.accreditation_requests_number_label')}:
                    </Col>
                    <Col>
                        {this.props.data.requestsNumber}
                    </Col>
                </Row>
                {this.props.data.requestsNumber ? <Row className="modal-form-field-container">
                    <Col sm={6}>
                        {_.get(this.props.translation, 'accreditation_requests.last_requestors_button')}:
                    </Col>
                    <Col>
                        {_.map(this.props.requestors, (elem, id) => {
                            return (
                                <div className="last-requestors-list" key={id}>
                                    {elem.identityAlias ? (elem.identityAlias.firstName + " " + elem.identityAlias.lastName) : ""}
                                    <br />
                                    <a href={"mailto:" + elem.email}>{elem.email}</a>
                                </div>
                            )
                        })}
                    </Col>
                </Row> : null}
                <div className="modal-buttons-container">
                    <Button color="secondary" onClick={this.handleClose}>
                        {_.get(this.props.translation, sharedLabelsPath.okey_button)}
                    </Button>
                </div>
            </div>
        );
    }

    handleClose = () => {
        this.props.onClose();
    };
}

ApplicantRequestsModal.propTypes = {
    requestors: PropTypes.array,
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onClose: PropTypes.func
};

export default ApplicantRequestsModal;



// WEBPACK FOOTER //
// ./src/components/accreditationManagement/accreditationModal/applicantRequestsModal/ApplicantRequestsModal.js